
class RangeListView {

    private readonly rangeView: HTMLDivElement | null | undefined;
    private readonly inputbar: HTMLInputElement | null | undefined;
    private readonly datalist: HTMLDivElement | null | undefined;
    private opciones:{text: string, value: string, selected: boolean, premiumoption: boolean}[] | null | undefined;
    private selectElement: ((value: (string | null)) => any) | undefined ;
    private lastIndex: number = 0;

    constructor(rangeViewElement:HTMLElement){
        this.rangeView =  <HTMLDivElement> rangeViewElement;
        if (this.rangeView) {
            this.inputbar = this.rangeView.getElementsByTagName("input")[0];
            this.datalist = this.rangeView.getElementsByTagName("div")[0];

            this.inputbar.addEventListener("input", this.change.bind(this));
        }


        document.addEventListener("overlayMenuOpened", (e: Event) => {
            const customEvent = e as CustomEvent;
            if ( customEvent.detail &&  customEvent.detail.menu && customEvent.detail.menu === "settings") {
                const index = <number><unknown> this.inputbar?.value;
                if(index >= this.lastIndex){
                    if (this.inputbar)
                        this.inputbar.value = this.lastIndex.toString();

                    this.change();
                }
            }

        });


    }



    update(opciones:{text: string, value: string, selected: boolean, premiumoption: boolean}[]){
        this.opciones = opciones;

        let index = 0;
        for (const opcion of this.opciones) {
            if (opcion.selected)
                break;
            index++;
        }

        if (index >= opciones.length)
            index= opciones.length - 1;

        if ( this.opciones ) {
            // this.inputbar?.setAttribute("max", (this.opciones.length - 1).toString());

            if (this.inputbar) {
                // this.inputbar.max = (this.opciones.length - 1).toString();
                this.inputbar.value = index.toString();
            }

            if(this.datalist)
            {
                this.datalist.innerHTML = "";

                let index = 0;
                this.lastIndex = 0;
                for (const opcion of this.opciones) {
                    const spanElement = document.createElement("span");
                    spanElement.innerText = opcion.text;

                    if (opcion.premiumoption)
                        spanElement.classList.add("premium");
                    else
                        this.lastIndex = index;

                    this.datalist.appendChild(spanElement);
                    index++;
                }
            }

            // if (this.output)
            //     this.output.innerText = this.opciones[index].text;
        }

    }

    change(){
        if (this.opciones && this.inputbar && this.datalist) {
            const index = <number><unknown> this.inputbar?.value;
            // this.output.innerText = this.opciones[index].text;

            if (this.selectElement && ! this.opciones[index].premiumoption)
                this.selectElement(this.opciones[index].value);

            // if (this.opciones[index].premiumoption)
            //     this.inputbar.value = this.lastIndex.toString();

            const max =  Number(this.inputbar.max);
            const minindex = Math.min(index, this.lastIndex)
            const porcentajemin = (minindex * (100 / max));
            const porcentaje = (index * (100 / max));


            const premiummsg = document.querySelector("#premiummsg");
            if (index > minindex){
                if (premiummsg && ! premiummsg.classList.contains("visible"))
                    premiummsg.classList.add("visible");

                if( !this.inputbar.classList.contains("premiumoptions"))
                    this.inputbar.classList.add("premiumoptions");
            }
            else{
                if (premiummsg && premiummsg.classList.contains("visible"))
                    premiummsg.classList.remove("visible");

                if(this.inputbar.classList.contains("premiumoptions"))
                    this.inputbar.classList.remove("premiumoptions");
            }

            this.inputbar.style.background = `linear-gradient(to right, #0074AD ${porcentajemin}%, #d3d3d3 ${porcentajemin}%)`;
            this.inputbar.style.background = `linear-gradient(to right, #0074AD ${porcentajemin}%, #89BAD2 ${porcentajemin}%, #89BAD2 ${porcentaje}%, #d3d3d3 ${porcentaje}%)`;

        }

    }

    bindSelect (handler: (value:string|null) => any){
        this.selectElement = handler;
    }

}


export default RangeListView;
